var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.tryCancel } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                  _vm.isEdit
                    ? _c("BjLogButton", {
                        attrs: {
                          id: _vm.recordId,
                          permission: "BusinessUserAccountIndex_Log",
                          title: _vm.form.realName,
                          api: "roleApi",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(_vm._s(_vm.$t("AccountManagementAdd.titile")) + " ")]
      ),
      _c(
        "el-form",
        {
          ref: "queryForm",
          attrs: {
            rules: _vm.rules,
            model: _vm.form,
            "label-width": "150px",
            "label-position": "top",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.name"),
                        prop: "realName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.realName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "realName", $$v)
                          },
                          expression: "form.realName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("BjFormItemMobile", {
                    attrs: {
                      prop: "phone",
                      label: _vm.$t("AccountManagementAdd.phone"),
                      required: "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("BjFormItemMobile", {
                    attrs: {
                      label: _vm.$t(
                        "AccountManagementAdd.internationalTelCode"
                      ),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.internationalTelCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "internationalTelCode", $$v)
                      },
                      expression: "form.internationalTelCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.account"),
                        prop: "loginName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: 20,
                          disabled: _vm.isEdit,
                          placeholder: _vm.$t("AccountManagementAdd.place"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.loginName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "loginName", $$v)
                          },
                          expression: "form.loginName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.Nickname"),
                        prop: "nickname",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.nickname,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nickname", $$v)
                          },
                          expression: "form.nickname",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.password"),
                        prop: "password",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          disabled: _vm.isEdit,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "password", $$v)
                          },
                          expression: "form.password",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.email"),
                        prop: "email",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.sex"),
                        prop: "gender",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: {
                            placeholder: _vm.$t("chooseText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.gender,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "gender", $$v)
                            },
                            expression: "form.gender",
                          },
                        },
                        _vm._l(_vm.GENDER_LIST, function (item) {
                          return _c("el-option", {
                            key: item.label,
                            attrs: {
                              label: _vm.$t(item.label),
                              value: item.value,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.address"),
                        prop: "regionId",
                      },
                    },
                    [
                      _c("BjRegionCascader", {
                        staticClass: "full-width",
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.form.regionId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "regionId", $$v)
                          },
                          expression: "form.regionId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.Detailed"),
                        prop: "addressDetail",
                      },
                    },
                    [
                      _c("BjInput", {
                        staticClass: "full-width",
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.addressDetail,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "addressDetail", $$v)
                          },
                          expression: "form.addressDetail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.Date"),
                        prop: "birthday",
                      },
                    },
                    [
                      _c("BjDatePicker", {
                        model: {
                          value: _vm.form.birthday,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "birthday", $$v)
                          },
                          expression: "form.birthday",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.from"),
                        prop: "startDateActive",
                      },
                    },
                    [
                      _c("BjDatePicker", {
                        model: {
                          value: _vm.form.startDateActive,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "startDateActive", $$v)
                          },
                          expression: "form.startDateActive",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.until"),
                        prop: "endDateActive",
                      },
                    },
                    [
                      _c("BjDatePicker", {
                        model: {
                          value: _vm.form.endDateActive,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endDateActive", $$v)
                          },
                          expression: "form.endDateActive",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagementAdd.deptAbbr"),
                        prop: "deptAbbr",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.deptAbbr,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "deptAbbr", $$v)
                          },
                          expression: "form.deptAbbr",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _vm.title === "编辑账户"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("AccountManagementAdd.Freeze"),
                            prop: "enabled",
                          },
                        },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.form.enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "enabled", $$v)
                              },
                              expression: "form.enabled",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [_vm._v(_vm._s(_vm.$t("AccountManagementAdd.Role")))]),
      _c(
        "el-row",
        { staticClass: "mb8", attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 1.5 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "delete-btn",
                  attrs: {
                    type: "danger",
                    icon: "el-icon-delete",
                    disabled: _vm.multiple,
                  },
                  on: { click: _vm.onDeleteSelected },
                },
                [_vm._v(_vm._s(_vm.$t("delText")))]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 1.5 } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                [_vm._v(_vm._s(_vm.$t("AccountManagementAdd.Add")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { data: _vm.roleTableData },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("AccountManagementAdd.RoleName"),
              align: "center",
              prop: "name",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("AccountManagementAdd.TenantName"),
              align: "center",
              prop: "tenantName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("AccountManagementAdd.from"),
              align: "center",
              prop: "name",
              width: "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("BjDatePicker", {
                      model: {
                        value: scope.row.startDateActive,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "startDateActive", $$v)
                        },
                        expression: "scope.row.startDateActive",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("AccountManagementAdd.until"),
              align: "center",
              prop: "name",
              width: "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("BjDatePicker", {
                      model: {
                        value: scope.row.endDateActive,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "endDateActive", $$v)
                        },
                        expression: "scope.row.endDateActive",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.queryParams.page,
          limit: _vm.queryParams.size,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "size", $event)
          },
        },
      }),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("AccountManagementAdd.Structure"))),
      ]),
      _c("BjCompanyTree", {
        staticClass: "mt16",
        attrs: { flag: true, "default-checked-keys": _vm.form.companyLists },
        on: { check: _vm.onChangeCompany },
      }),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          config: _vm.dialogListConfig,
          disabled: _vm.disabledIds,
          multiple: "",
        },
        on: { confirm: _vm.onConfirmDialogList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }